exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.nil-sa-elements-creditcardnumber__cardNumber{display:inline-block}", ""]);

// exports
exports.locals = {
	"cardNumber": "nil-sa-elements-creditcardnumber__cardNumber"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/CreditCardNumber/index.less
// module id = 419
// module chunks = 0